import { render, staticRenderFns } from "./PuiSelectTextService.vue?vue&type=template&id=e7f70ee2"
import script from "./PuiSelectTextService.vue?vue&type=script&lang=js"
export * from "./PuiSelectTextService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports